import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { PlumXCloseIcon } from '@ui/icons/src/PlumXCloseIcon';
import { VisuallyHidden } from '../VisuallyHidden';
import { XButton } from './styles.js';

export const CloseButton = ({
  onClick,
  color = 'border.light',
  usePlumX = false,
  withoutCircle = false,
}) => {
  return (
    <XButton onClick={onClick}>
      {usePlumX ? (
        <PlumXCloseIcon alt="" size="40" color={color} />
      ) : (
        <Icon
          iconName={withoutCircle ? 'close' : 'close-circle'}
          size="40px"
          color={color}
          alt=""
          id="close_button"
        />
      )}
      <VisuallyHidden>Close Modal</VisuallyHidden>
    </XButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
  usePlumX: PropTypes.bool,
};
